export default {
  methods: {
    get_table_rows_source(raw_table) {
      if (Array.isArray(raw_table.rows)) return raw_table.rows;
      if (Array.isArray(raw_table.data)) return raw_table.data;
      return [];
    },

    get_normalized_headers(headers, first_row) {
      if (headers.length) return headers;
      if (first_row && typeof first_row === 'object' && !Array.isArray(first_row)) {
        return Object.keys(first_row);
      }
      return [];
    },

    normalize_table_row(row, headers) {
      if (Array.isArray(row)) return row;
      if (row && typeof row === 'object') {
        if (headers.length) {
          return headers.map((h) => this.safe_obj_get(row, h) ?? this.safe_obj_get(row, this.safe_key(h)) ?? '');
        }
        return Object.values(row);
      }
      return [String(row ?? '')];
    },

    section_table_payload(section) {
      const raw = section?.table;
      if (!raw) return null;
      const headers = Array.isArray(raw.headers) ? raw.headers.filter((h) => typeof h === 'string') : [];
      const rows_source = this.get_table_rows_source(raw);
      if (!rows_source.length) return null;
      let normalized_headers = this.get_normalized_headers(headers, this.safe_array_get(rows_source, 0));
      const normalized_rows = rows_source.map((r) => this.normalize_table_row(r, normalized_headers));
      if (!normalized_headers.length && normalized_rows.length) {
        const max_cols = normalized_rows.reduce((m, c) => (Array.isArray(c) ? Math.max(m, c.length) : m), 0);
        normalized_headers = Array.from({ length: max_cols }, (_, i) => `Column ${i + 1}`);
      }
      return { headers: normalized_headers, rows: normalized_rows };
    },
  },
};
